import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  itemCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  itemCount,
  onConfirm,
  onCancel,
}) => {
  const handleClose = () => {
    onCancel();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Dialog open={isOpen} onOpenChange={open => !open && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Deletion</DialogTitle>
        </DialogHeader>
        <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
          <p className="text-md m-2 text-gray-500">
            Are you sure you want to delete <strong>{itemCount}</strong> selected {itemCount === 1 ? "item" : "items"}?
          </p>
          <p className="m-2 text-sm text-gray-400">This action cannot be undone.</p>
        </div>
        <div className="mt-4 flex justify-between">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleConfirm}>
            Delete {itemCount} {itemCount === 1 ? "item" : "items"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
